import { render } from "./YitIcon.vue?vue&type=template&id=c33e97ea&scoped=true"
import script from "./YitIcon.vue?vue&type=script&lang=js"
export * from "./YitIcon.vue?vue&type=script&lang=js"

import "./YitIcon.vue?vue&type=style&index=0&id=c33e97ea&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c33e97ea"]])

export default __exports__